import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Image,
  Container,
  Col,
  Row,
  Button,
  InputGroup,
} from "react-bootstrap";
import Msgpic from "../../assets/user.png";
import { MessageDetailApi } from "../../Utils/Api/MessageDetails";
import Moment from "moment";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getChatFlagGeneralSlice } from "../../redux/ChatFlagSlice";

const GeneralRelated = ({ props, flagFetchHandler }) => {
  const navigate = useNavigate();
  const parameter = useParams();
  const [chatHistory, setChatHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectChannelLog, setselectedChannelLog] = useState("");

  const dispatch = useDispatch();

  const Handler = async () => {
    setLoading(true);
    const ChatHistory = await MessageDetailApi(() => {
      navigate("/");
    });
    setLoading(false);
    setChatHistory(ChatHistory.data);
  };

  useEffect(() => {
    Handler();
  }, []);

  function handleClick(chat_id) {
    navigate(`/messages/${chat_id.channel_id.toString()}`, {
      state: {
        productName: chat_id.product_name,
        businessName: chat_id.business_name,
        profileImage: chat_id.eu_profile_image,
        firstName: chat_id.end_user_first_name,
      },
    });
    setselectedChannelLog(chat_id.channel_id);
    dispatch(getChatFlagGeneralSlice(true));
  }
  const ReduxData = useSelector((state) => state.ChatFlag);

  const GeneralFlag = ReduxData.ChatFlagGeneral;

  return (
    <>
      <div style={{ cursor: "pointer" }}>
        {chatHistory && true ? (
          chatHistory.map((item) => {
            return item.chat_type == 2 ? (
              <div
                className={
                  selectChannelLog === item.channel_id && GeneralFlag == true
                    ? "d-flex msg-main1 active_chat"
                    : "d-flex msg-main1"
                }
                onClick={() => {
                  handleClick(item);
                  flagFetchHandler(false);
                }}
              >
                <div className="msgpic">
                  <Image
                    loading="lazy"
                    src={item.eu_profile_image ? item.eu_profile_image : Msgpic}
                  ></Image>
                </div>
                <div className="msg-1">
                  <p className="msg1-text0">{item.end_user_first_name}</p>
                  <p className="msg1-text1">{item.product_name}</p>
                  <p className="msg1-text2">{item.business_name}</p>
                </div>
                {/* <div className="msg-2">
                  <p className="msg2-text1">
                    {Moment(item.created_at).format("HH:MM:SS")}
                  </p>
                </div> */}
              </div>
            ) : null;
          })
        ) : (
          <p className="NoDataAvailable" style={{ color: "black" }}>
            No data available!
          </p>
        )}
      </div>
    </>
  );
};

GeneralRelated.propTypes = {};

export default GeneralRelated;
